import type { AvailableUnits } from '@cw-elements/profile-dropdown/utils/contants';

export enum FeatureFlags {
  NO_TIMELINE = 'NO_TIMELINE',
  NO_HEATMAP = 'NO_HEATMAP'
}

export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
  ASC_ALPHABETIC = 'ASC_ALPHABETIC',
  DESC_ALPHABETIC = 'DESC_ALPHABETIC',
  ASC_LAST_VISIT = 'ASC_LAST_VISIT',
  DESC_LAST_VISIT = 'DESC_LAST_VISIT'
}

export enum UnitType {
  KILOGRAMS = 'KILOGRAMS',
  LITERS = 'LITERS',
  UNITS = 'UNITS',
  BOXS = 'BOXS',
  SACK = 'SACK',
  GALLONS = 'GALLONS',
  GRAMS = 'GRAMS',
  TONNES = 'TONNES',
  MILLILITER = 'MILLILITER',
  METERS = 'METERS',
  OUNCES = 'OUNCES',
  POUNDS = 'POUNDS',
  PINTS = 'PINTS',
  DOSE = 'DOSE'
}

export enum TimeUnitType {
  MILLISECOND = 'MILLISECOND',
  NANOSECOND = 'NANOSECOND',
  MICROSECOND = 'MICROSECOND',
  SECOND = 'SECOND',
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export enum ProductType {
  // Others
  VARIETY = 'VARIETY',
  FUEL = 'FUEL',
  PART = 'PART',
  GENERIC_PRODUCT = 'GENERIC_PRODUCT',
  LUBRICANT = 'LUBRICANT',
  INOCULANT = 'INOCULANT',

  // Defensive
  ADJUVANT = 'ADJUVANT',
  HERBICIDE = 'HERBICIDE',
  FUNGICIDE = 'FUNGICIDE',
  FERTILIZER = 'FERTILIZER',
  PESTICIDE = 'PESTICIDE',
  INSECTICIDE = 'INSECTICIDE'
}

export enum LissThresholds {
  MIN_CONTROL = 60,
  MIN_DAMAGE = 90
}

/**
 * These enums are for the "wk_slug" field.
 * Note that the server might return the value in different casing (e.g. "wheat" vs "WHEAT").
 */
export enum CropTypesEnum {
  APPLE = 'apple',
  BEAN = 'bean',
  COFFEE = 'coffee',
  CORN = 'corn',
  CORN_MAIZ = 'maiz',
  COTTON = 'cotton',
  GRAPE = 'grape',
  HARD_WHEAT = 'hard_wheat',
  LEMON = 'lemon',
  ORANGE = 'orange',
  POTATO = 'potato',
  RICE = 'rice',
  SOYBEANS = 'soybeans',
  SOYBEAN = 'soybean',
  SPRING_BARLEY = 'spring_barley',
  SUGARCANE = 'sugarcane',
  TOMATO = 'tomato',
  WATERMELON = 'watermelon',
  WINTER_BARLEY = 'winter_barley',
  WINTER_WHEAT = 'winter_wheat',
  BRACHIARIA = 'brachiaria',
  ACEROLA = 'acerola',
  ALFALFA = 'alfalfa',
  ASPARAGUS = 'asparagus',
  ATEMOYA = 'atemoya',
  AVOCADO = 'avocado',
  BANANA = 'banana',
  BLUEBERRY = 'blueberry',
  CHERRY = 'cherry',
  COFFEE_BEAN = 'coffee_bean',
  OILSEED_RAPE = 'oilseed_rape',
  ONION = 'onion',
  SUNFLOWER = 'sunflower',
  TURNIP = 'turnip',
  /**
   * These two crops are generic ones (bigger than the disease risk
   * feature), and they can be used to filter regions from the Cropwise
   * platform, for example
   */
  WHEAT = 'wheat',
  BARLEY = 'barley'
}

export enum Threshold {
  DAMAGE = 'DAMAGE',
  ACCEPTANCE = 'ACCEPTANCE',
  CONTROL = 'CONTROL',
  NONE = 'NONE',
  SPRAY = 'SPRAY',
  ENDED = 'ENDED'
}

export enum ThresholdColor {
  DAMAGE = '#F74141',
  ACCEPTANCE = '#2FB966',
  CONTROL = '#FFCA28',
  SPRAY = '#0568FA',
  NONE = '#707374'
}

export const INITIAL_PAGE = {
  number: 0,
  size: 0,
  pages: 0,
  total: 0,
  total_pages: 0,
  mutableContent: []
};

export const INITIAL_PAGE_V4 = {
  content: [],
  empty: false,
  first: false,
  last: false,
  number: 0,
  number_of_elements: 0,
  size: 0,
  total_elements: 0,
  total_pages: 0
};

export const UnitSystem: Record<string, AvailableUnits> = {
  METRIC: 'metric',
  IMPERIAL: 'imperial',
  CANADA: 'canada'
} as const;

export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;
export const TEN_MINUTES_IN_MS = 10 * 60 * 1000;
